<template>
  <div class="mb-8 rounded-2xl border border-orange-100/60 bg-orange-50/40 px-6 py-4 backdrop-blur-sm dark:border-orange-900/20 dark:bg-orange-900/5">
    <div class="flex items-start gap-4">
      <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-orange-100 dark:bg-orange-900/40">
        <InformationCircleIcon class="h-6 w-6 text-orange-600 dark:text-orange-400" />
      </div>
      <div class="text-sm">
        <p class="font-bold text-orange-800 dark:text-orange-200 tracking-wide">演示模式</p>
        <p class="mt-1 text-orange-600 dark:text-orange-400/80 leading-relaxed">
          品牌设置可真实修改，其余数据仅供展示，不支持实际操作。
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
</script>
